import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            游戏分类
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            按游戏类型浏览，找到最适合你的火影同人游戏
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-4 md:p-5 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 no-underline flex flex-col items-center text-center gap-3 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <span className="text-sm md:text-base font-heading font-bold text-foreground-900 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 leading-relaxed hidden md:block">
                {cat.description.length > 28 ? cat.description.slice(0, 28) + '...' : cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}